import React, { Component } from "react";
import { Layout } from "../components/Layout";

import CrearPubl from "../components/CrearPublicacion";
import InfoPerfil from "../components/InfoPerfil";
import { Wrapper } from "../layout/Wrapper";
import EstadoAplicaciones from "../components/EstadoAplicaciones";
import EmpleosGuardados from "../components/EmpleosGuardados";
import VacantesInteresar from "../components/VacantesInteresar";

// import "../css/pag-principal.css";

class PaginaPrincipal extends Component {
  render() {
    const usuario = {
      Nombre: "Maria Rodríguez",
      Cargo: "Asistente de comunicación",
      Foto: "../static/images/user.png",
      //Contactos: "25",
      Grupos: "5",
      Insignias: "4",
    };
    const aplicaciones = {
      Cargo: "Gerente de Operaciones",
      Empresa: "Flor de Caña Rum",
      Estado: "./",
      Progreso: "40",
      Icono: "./",
    };
    const left = [
      { componente: <InfoPerfil usuario={usuario} /> },
      { componente: <EmpleosGuardados /> },
      { componente: <VacantesInteresar /> },
    ];
    const center = [{ componente: <CrearPubl /> }];
    const rigth = [
      { componente: <EstadoAplicaciones aplicaciones={aplicaciones} /> },
    ];
    return (
      <div>
        <Wrapper left={left} center={center} rigth={rigth}></Wrapper>
      </div>
    );
  }
}

export default PaginaPrincipal;
